import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Payment } from '../types';

export function usePendingPayments() {
  return useQuery({
    queryKey: ['payments-pending'],
    queryFn: async (): Promise<Payment[]> =>
      pb.send('/api/payments/pending', { method: 'GET' }),
    staleTime: 30_000,
  });
}
